import React from 'react';
import { CarouselContentCardProps } from './carousel-content-card.props';
import LazyLoad from 'react-lazyload';

export const CarouselContentCardMolecule = (
  props: CarouselContentCardProps
) => {
  return (
    <div className="block bg-white mx-auto w-72 lg:w-77 py-7 lg:py-10 h-105 lg:h-80 flex flex-row justify-center">
      <div className="w-21/25 lg:w-17/20 ml-4 lg:ml-0">
        <div className="flex items-center lg:items-start h-44 lg:h-28 w-52 lg:w-4/5 mx-0 lg:mx-auto">
          <LazyLoad offset={100}>
            <img
              src={`/images/icons/doctor-ambassador/benefits/${props.image}`}
            />
          </LazyLoad>
        </div>
        <p className="block font-semibold text-mobileHeader lg:text-base leading-5.3 lg:leading-5 mt-3 text-waldo-blue w-full mt-5">
          {props.title}
        </p>
        <p className="block text-mobileHeader lg:text-base  leading-5.3 lg:leading-5.5 mt-3 text-waldo-blue w-full">
          {props.content}
        </p>
      </div>
    </div>
  );
};
